import Api from './Api';

class TipoAcabamentoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-acabamento', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-acabamento', data);
    }

    return this.$api.put(`/tipo-acabamento/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-acabamento/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-acabamento/${id}`);
  }
}

export default new TipoAcabamentoService();
